import {
  createContext,
  useContext,
  useState,
  useMemo,
  ReactNode,
  Dispatch,
  SetStateAction
} from 'react';

interface SibcyContextType {
  isSibcyListing: boolean;
  setIsSibcyListing: Dispatch<SetStateAction<boolean>>;
}

const SibcyListingContext = createContext<SibcyContextType>({
  isSibcyListing: false,
  setIsSibcyListing: () => {}
});

export const SibcyListingProvider = ({ children }: { children: ReactNode }) => {
  const [isSibcyListing, setIsSibcyListing] = useState(false);
  const value = useMemo(() => ({ isSibcyListing, setIsSibcyListing }), [isSibcyListing]);
  return <SibcyListingContext.Provider value={value}>{children}</SibcyListingContext.Provider>;
};

export const useSibcyListing = () => useContext(SibcyListingContext) ?? { isSibcyListing: false };
